export const TRANSLATIONS_EN = {
    jobList: "Job List",
    activeJobs: "No. of Active Jobs",
    lang: "Language",
    completedJobs: "Completed Jobs",
    totalRecordsIn: "Total Records In",
    totalRecordsOut: "Total Records Out",
    noCores: "Number of Cores",
    tasks: "Tasks (coop/non-coop)",
    heapUsage: "Heap Usage (GB)",
    results: "Results",
    cache: "Cache",
    notConnected: "Not Connected",
    connected: "Connected",
    uploadedFiles: "Uploaded Files",
    restartBC: "Restart BlueCardinal",
    addJob: "Add New Operator",
    version: "Version",
    viewFullList: "View Full List",
    errors: "Errors",
    currentLogs: "Current Logs",
    refresh: "Refresh",
    cpuUsage: "CPU Usage",
    downloadFullLogs: "Download Full Logs",
    viewAllLogs: "View All Logs",
    createNewOperator: "Create New Operator",
    toDashboard: "To Dashboard",
    addExternalConfig: "Add External Config",
    submit: "Submit",
    logList: "Log List",
    toJobList: "To Job List",
    download: "Download",
    notifications: "Notifications",
    logout: "Logout",
    logSnippet: "Log Snippet",
    noLogs: "Logs are not available yet.",
    jobName: "Job Name",
    jobId: "Job ID",
    jobStatus: "Status",
    jobStartTime: "Start Time",
    jobRecordsIn: "Records In",
    jobRecordsOut: "Records Out",
    manageAcc: "My Account"
};
